var mixin = require('../common/mixin')
var getUA = require('../common/get-ua')
var Semver = require('../common/semver')
var Perf = require('../common/perf')

var noop = function () {}
var UA = getUA.internal()

var callbackUtil = {
  getName: function (callbackId) {
    return 'DPApp_callback_' + callbackId
  },
  // callbackid算法为依次递增
  getId: function () {
    window.__TITANS_COUNT = window.__TITANS_COUNT || 1;
    if (typeof window.__TITANS_COUNT !== 'number') {
      throw new Error('[KNB] __TITANS_COUNT invalid!');
    }
    return ++window.__TITANS_COUNT + '';
  }
}

var isForceDebug = function () {
  return location.href.indexOf('knb_force_titans_debug=1') > -1
}

var mtnbCBID = 1
var messageHandlers = {}
function regHandler (fn) {
  var id = 'cb_' + (mtnbCBID++) + '_' + new Date().getTime()
  messageHandlers[id] = fn
  return id
}

var DPApp = {
  readyError: null,
  _delay: 1000,
  _isDebug: false,
  _dequeueTimeout: null,
  defaultTimeout: 2000,

  //防止@dp/app重写Titans的DPApp
  __type__: 'npm',
  __name__: 'titansX',
  queue: undefined,
  readyQueue: [],
  _isReadying: false,
  config: function (config) {
    this._isDebug = config.debug;
    this._isReady = config.ready;
    this._delay = config.delay || 1000;
  },
  setBridge: function (bridge) {
    if (typeof bridge === 'function') {
      this._bridge = bridge
      this._delay = 0
    } else {
      this._bridge = bridge.name
      this._delay = bridge.delay
    }
  },
  log: function () {
    var arguments$1 = arguments;

    var message = []
    for (var i = 0; i < arguments.length; i++) {
      if (typeof arguments$1[i] == 'string') {
        message.push(arguments$1[i])
      } else if (arguments$1[i] != undefined) {
        message.push(JSON.stringify(arguments$1[i]))
      }
    }

    if (this._isDebug || isForceDebug()) return setTimeout(function () { return alert(message.join(' ')); })
    if (window._KNB_LOG) return window._KNB_LOG(message.join(' '))
  },
  ready: function (callback) {
    var self = this
    if (self._isReady) {
      return callback && callback(self.readyError);
    }

    if (self._isReadying) {
      return self.readyQueue.push(callback)
    }else{
      self._isReadying = true
    }

    self.log('[Auth   ]: 正在进行鉴权')
    this.callNative('ready', {
      success: function (result) {
        if (result.errorCode === -403) {
          self.readyError = new Error(-403);
        } else {
          self.log('鉴权成功')
        }
        self._isReady = true;
        self._isReadying = false;
        self.readyQueue.forEach(function(cb) {
          cb && cb(self.readyError);
        })
        self.readyQueue = []

        //fix config ready Bug
        callback && callback(self.readyError);
      },
      fail: function (error) {
        self.readyError = error;
        self._isReady = true;
        self._isReadying = false;
        self.log('鉴权失败', error)
        self.readyQueue.forEach(function(cb) {
          cb && cb(error);
        })
        self.readyQueue = []

        //fix config ready Bug
        callback && callback(error);
      }
    })
  },
  callNative: function (method, args) {
    if ( args === void 0 ) args = {};

    this.log('[Call  ]', method)
    var self = this

    function wrap (name, fn) {
      return function (result) {
        self.log(("[" + name + " ] " + method), result)
        fn && fn.call(self, result)
      }
    }

    // Wrap with log info
    var fail = wrap('Failed', args.fail)
    var success = wrap('Success', args.success)
    var handle = wrap('Trigger', args.handle)

    // adapt for MTNB proxy
    args = mixin({
      handlerId: regHandler(handle)
    }, args)

    self.doSendMessage(method, args, function callback (result) {
      var status = result.status
      var data = result.__isFromMTNB ? result.data : result
      if (status === 'success' || String(status) == '0') return success(data)
      if (status === 'action') return handle(data)
      return fail(result);
    });
  },
  
  dequeue: function (source) {
    source = source || 'Native'
    var self = this
    this.log('[Dequeue]', 'by' , source)
    setTimeout(function () {
      self._dequeueTimeout && clearTimeout(self._dequeueTimeout);
      self._dequeueTimeout = null
      self.queue && self.queue.dequeue && self.queue.dequeue();
    }, 0)
  },
  doSendMessage: function (method, args , callback) {
    if ( args === void 0 ) args = {};

    var callbackId = this.createCallback(callback, !!args.handle, method);

    args = JSON.stringify(args)

    var message = 'js://_?method=' + method + '&callbackId=' + callbackId + '&args=' + encodeURIComponent(args)
    this.log('[Send]', method, 'with callbackId:', callbackId, 'has params: ', args)

    if (typeof this._bridge === 'function') return this._bridge(message)
    if (this._bridge === 'prompt') return this.sendByPrompt(message, callbackId)
    if (this._bridge === 'interface') return this.sendByInterface(message, callbackId)
    if (Semver.gte(UA.titansxVersion, '11.25')) return this.sendByMessageHandler(message, method, args, callbackId);
    this.sendByIframe(message)
  },
  sendByPrompt: function (message, callbackId) {
    this.log('[Send By Prompt]', message)
    if (message.length > 10240) return this.callback(callbackId, {status: 'fail', errorCode: 12, errorMsg: '桥协议过长' })
    window.prompt(message)
  },
  sendByInterface: function (message, callbackId){
    // 兼容低版本 Android 通信可能报错的情况
    if (window.KNBTitansX && window.KNBTitansX.sendMessage) {
      this.log('[Send By Interface]', message);
      window.KNBTitansX.sendMessage(message);
    } else {
      this.log('[Send By Prompt]', message);
      this.sendByPrompt(message, callbackId);
    }
  },
  sendByMessageHandler: function (message, method, args, callbackId) {
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.titans) {
      this.log('[Send By WKScriptMessageHandler]', message);
      window.webkit.messageHandlers.titans.postMessage({
        method: method,
        args: args,
        callbackId: ("" + callbackId)
      });
    } else {
      this.sendByIframe(message);
    }
  },
  sendByIframe: function (message) {
    this.log('[Send By iframe]', message)
    var node = document.createElement('iframe')
    node.style.display = 'none'

    var removeNode = function () {
      node.onload = node.onerror = null
      node.parentNode && node.parentNode.removeChild(node)
    }

    /*
      remove node after loaded or error
      */
    node.onload = node.onerror = removeNode
    setTimeout(removeNode, 3000)
    node.src = message;
    (document.body || document.documentElement).appendChild(node)
  },
  createCallback: function (callback, isHandleExisted, method) {
    var callbackId = 0, callbackName

    if (typeof callback === 'function') {
      callbackId = callbackUtil.getId()
      callbackName = callbackUtil.getName(callbackId)
      window[callbackName] = callback;

      // 没有handle回调，可以安全清除
      callback.isSafeDelete = !isHandleExisted;
      callback.startTime = Date.now();
      callback.method = method;
    }

    return callbackId
  },
  //Titans的调用callback时,把callbackId绑定在了window上,然后native调用window[callbackId]
  callback: function (callbackId, retValue, isFromMTNB) {
    this.log('[Call Callback]', callbackId)
    // handle message from native
    var win = window;
    var self = this;
    var callbackName = callbackUtil.getName(callbackId)
    var callback = window[callbackName]
    if (!callback) return
    if (retValue && isFromMTNB) retValue.__isFromMTNB = true
    setTimeout(function () {
      if(callback.startTime) {
        var execTime = Date.now() - callback.startTime;
        if(execTime > self.defaultTimeout) {
          // 上报
          Perf.sendTimeoutPerf({
            bridgeName: callback.method
          })
        }
        // 如果是fail,数据失真，不上报全流程埋点
        if(retValue && retValue.status !== 'fail') {
          Perf.sendPerf({
            execTime: execTime,
            bridgeName: callback.method,
            stage: 'wholeProcess'
          })
        }
        if(retValue && retValue.knbExtra && retValue.knbExtra.log && retValue.knbExtra.log.nativeReceivedTimestamp) {
          Perf.sendPerf({
            execTime: retValue.knbExtra.log.nativeReceivedTimestamp  - callback.startTime,
            bridgeName: callback.method,
            stage: 'touchNativeTime'
          })
        }
      }

      callback.call(self, retValue);

      if(retValue && retValue.knbExtra && retValue.knbExtra.log && retValue.knbExtra.log.nativeCallbackTimestamp) {
        Perf.sendPerf({
          execTime: Date.now()  - retValue.knbExtra.log.nativeCallbackTimestamp,
          bridgeName: callback.method,
          stage: 'callbackExecTime'
        })
      }
      
      // force gc
      if (callback.isSafeDelete) {
        win[callbackName] = null;
        delete win[callbackName];
      }
    }, 0)
  }
}

// 默认设置android的桥方式为prompt
if (UA.osName === 'android') {
  if (Semver.gte(UA.osVersion, '4.2.0') && typeof window.KNBTitansX === 'object' && window.KNBTitansX.sendMessage 
    && Semver.gte(UA.titansxVersion, '11.1.0')) {
    DPApp.setBridge({
      name: 'interface',
      delay: 50
    })
  } else {
    DPApp.setBridge({
      name: 'prompt',
      delay: 200
    })
  }
}

// Adapt for MTNB call from Native
if (window.MTNB) {
  console.log('you env has already register MTNB')
} else {
  // Declare the ability of dealing with MTNB callback
  window.MTNB = {
    _handleMessageFromApp: function _handleMessageFromApp(message) {
      DPApp.log('[MTNB] ', 'get message:' , message)
      if (message.callbackId) return DPApp.callback(message.callbackId, message.data, true)
      return (messageHandlers[message.handlerId] || noop)(message.data)
    }
  }
}

//覆盖Hippo   Hippo须保证在1.2.27以上版本
if (!window.DPApp || window.DPApp.__type__ === 'hippo' || window.DPApp.fromKNBCore) {
  window.DPApp = DPApp
  DPApp.ready() // init first
}else if(window.DPApp.__name__ === 'titansX'){
  //防止titansX的DPApp重复加载
  DPApp = window.DPApp
}else if(window.DPApp && window.DPApp.dequeue){
  //titans DPApp非全局DPApp时，释放队列
  var _origin = window.DPApp.dequeue
  window.DPApp.dequeue = function(){
    _origin.apply(window.DPApp, arguments)
    DPApp.dequeue.apply(DPApp, arguments)
  }
}



if (isForceDebug()) alert('[Titans UA] ' + navigator.userAgent)

module.exports = DPApp



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/compiled/titans/bridge.js
// module id = 340
// module chunks = 0